import { render } from "./template-incorporation-form-step-2.vue?vue&type=template&id=208b57e6"
import script from "./template-incorporation-form-step-2.vue?vue&type=script&lang=js"
export * from "./template-incorporation-form-step-2.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__